import { render, staticRenderFns } from "./OrbitLearnMoreModal.vue?vue&type=template&id=2c8248f0&scoped=true"
import script from "./OrbitLearnMoreModal.vue?vue&type=script&lang=ts"
export * from "./OrbitLearnMoreModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitLearnMoreModal.vue?vue&type=style&index=0&id=2c8248f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8248f0",
  null
  
)

export default component.exports